import ScrollWrapper from "../../Components/ScrollWrapper";
import Text from "../../Components/Text";
import SmallImage from "../../Components/SmallImage";
import ChapterToggler from "../../Components/ChapterToggler";

const StatisticInstructions = () => {
    return (
        <ScrollWrapper>
            <div className="w-full h-full flex flex-col p-3 gap-4">
                <Text type="maintitle">Statistik</Text>
                <SmallImage src={"instructions/kitchen-monitor.png"} />

                {/* Übersicht */}
                <div className="w-full flex flex-col">
                    <Text type="title">1. Modus Wechsler</Text>
                    <Text type="title">2. Bestellungsauflistung</Text>
                </div>

                {/* 1. Modus Wechsler */}
                <ChapterToggler title="1. Modus Wechsler">
                    <Text type="itemtext">
                        Der Modus Wechsler ist standardmässig auf <b>„Offen“</b> eingestellt.
                        Bei Offen werden alle offenen Bestellungen angezeigt.
                        Bei Abgeschlossen werden alle alten Bestellungen grau aufgelistet.
                        Zusätzlich wird die benötigte Zeit angezeigt, die für das Abschliessen
                        der Bestellung benötigt wurde.
                    </Text>

                    <Text type="itemtext">
                        Man kann zum Hauptmenu zurückkehren, indem man den
                        <b> „Zurück“ </b> Knopf oben links drückt.
                    </Text>

                    <br />

                    <div className="flex gap-4 w-full flex-wrap">
                        <SmallImage
                            src={"instructions/open.png"}
                            subtitle="Offen Modus"
                        />
                        <SmallImage
                            src={"instructions/closed.png"}
                            subtitle="Abgeschlossen Modus"
                        />
                    </div>
                </ChapterToggler>

                {/* 2. Bestellungsauflistung */}
                <ChapterToggler title="2. Bestellungsauflistung">
                    <Text type="itemtext">
                        Hier werden alle Bestellungen angezeigt.
                        Wenn der <b>„Offen“</b> Modus gewählt ist, sind dies alle Bestellungen,
                        die noch nicht abgeschlossen wurden. Diese sind farbig dargestellt.
                        Die Farben haben folgende Bedeutung:
                    </Text>

                    <Text type="itemtext">🔵 Blau: Bestellung zum Vor-Ort-Konsumieren</Text>
                    <Text type="itemtext">🟢 Grün: Bestellung zum Mitnehmen</Text>
                    <Text type="itemtext">
                        ⚪ Grau: Vorbestellung oder abgeschlossen (wenn „Abgeschlossen“ gewählt wurde)
                    </Text>

                    <br />

                    <Text type="itemtext">
                        Bestellungen können entweder über den
                        <b> „Abschliessen“ </b> Knopf oder durch das
                        <b> Wischen nach rechts </b> abgeschlossen werden.
                    </Text>

                    <br />

                    <Text type="itemtext">
                        Jede Bestellung ist folgend aufgebaut:
                    </Text>
                    <Text type="itemtext">
                        <b>Anzahl | Produkt | Extras (falls ausgewählt)</b>
                    </Text>
                    <Text type="itemtext">
                        Anschliessend folgt die Zeit, wie lange die Bestellung offen ist.
                    </Text>

                    <br />

                    <SmallImage
                        src={"instructions/orders.png"}
                        smallSize="w-1/2"
                    />
                </ChapterToggler>
            </div>
        </ScrollWrapper>
    );
};

export default StatisticInstructions;
